import React from "react";
import Headshot from "../assets/images/Rouzbeh_Headshotmain.jpg";
import "./Hero.scss";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import GitHubIcon from "@mui/icons-material/GitHub";
import TwitterIcon from "@mui/icons-material/Twitter";
import SchoolIcon from "@mui/icons-material/School";

import "animate.css";

const Hero = () => {
  return (
    <>
      <Container maxWidth="lg">
        <div id="About" className="flex justify-center items-center flex-col">
          <img
            className="headShot mt-16"
            src={Headshot}
            alt="Headshot of Rouzbeh Rahai"
          />
          <h1 className="text-5xl mt-4 font-bold">Rouzbeh Rahai</h1>

          <p color="secondary" className="text-xl mt-2">
            Doctoral Researcher | Cornell University
          </p>
          <span className="mt-4 mx-4">
            I am earning my doctorate at Cornell University in Design and
            Environmental Analysis with minor distinctions in Data Science and
            Systems Engineering.
            {/* Check out my research website:{" "}
            <a
              className="haleLink"
              target="_blank"
              href="https://www.halle-lab.com"
            >
              HALLE- Heat, Air, and Living & Learning Environments.
            </a> */}
          </span>
          <div className="flex justify-center mt-6 gap-1 mb-24">
            <a target="_blank" href="https://www.linkedin.com/in/rouzbeh-rahai">
              <LinkedInIcon color="primary"></LinkedInIcon>
            </a>
            <a target="_blank" href="https://www.github.com/rouzbehrahai">
              <GitHubIcon></GitHubIcon>
            </a>
            <a target="_blank" href="https://x.com/RouzbehRahai">
              <TwitterIcon sx={{ color: "#1DA1F2" }}></TwitterIcon>
            </a>
            <a
              target="_blank"
              href="https://scholar.google.ca/citations?user=qNm9hxsAAAAJ&hl=en&oi=ao"
            >
              <SchoolIcon sx={{ color: "#4285F4" }}></SchoolIcon>
            </a>
          </div>
        </div>
      </Container>
    </>
  );
};

export default Hero;
